import React from "react";
import Header from "./Components/Header";
import BlogCard from "./Components/BlogCard";
import Footer from "./Components/Footer";

const BlogPage = () => {
  return (
    <>
      <Header />
      <BlogCard />
      <Footer />
    </>
  );
};

export default BlogPage;
